import React, { useMemo } from "react";
import _Input from "../../generic/_Input";
import _Select from "../../generic/_Select";
import { useFormikContext } from "formik";
import TotalAudience from "../TotalAudience";

const GeneralData = () => {
  const { values, handleChange, errors, handleBlur } = useFormikContext();
  const { listDatabases = [], campaignName, uiddatabase } = values;

  const databases = useMemo(() => {
    const isArray = Array.isArray(listDatabases);
    return isArray ? listDatabases : [];
  }, [listDatabases]);

  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="text-xl font-bold text-gray-600">Datos Generales</div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col py-2">
          <_Input
            title="Nombre de la Campaña"
            name="campaignName"
            id="campaignName"
            type="text"
            value={campaignName}
            onChange={handleChange}
            placeholder="Ejemplo: Promoción de Verano"
            onBlur={handleBlur}
            errors={errors && errors.campaignName}
            isError={errors && errors.campaignName ? true : false}
            required
          />
        </div>

        <div className="flex flex-col py-2">
          <_Select
            title="Base de Datos"
            required
            name="uiddatabase"
            id="uiddatabase"
            value={uiddatabase}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.uiddatabase}
            isError={errors && errors.uiddatabase ? true : false}
            options={[
              {
                value: "",
                label: "Selecciona de la lista",
              },
              ...databases.map((item) => ({
                value: item.uiddatabase,
                label: item.name,
              })),
            ]}
          />
        </div>
      </div>
      <TotalAudience />
    </div>
  );
};

export default GeneralData;
